import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

const NavBar = () => {

  return (
      <div>
        <Navbar collapseOnSelect sticky="top" expand="sm" bg="dark" variant="dark">
          <Container>
            <Navbar.Brand href="#home">Ray Russell Art</Navbar.Brand>
            <Navbar.Toggle aria-controls='responsive-navbar-nav' />
            <Navbar.Collapse id='responsive-navbar-nav'>
              <Nav className="ml-auto mr-4">
                <Nav.Link href='/#about'>About the Artist</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
  );
}


export default NavBar;
